import {Accordion} from '@/components-v2/molecules'
import {ComboReviewDisplay} from './ComboReviewDisplay'
import {ComboReviewProducts} from './ComboReviewProducts'
import {ComboReviewSetup} from './ComboReviewSetup'

export const ProductComboReview = () => {
  return (
    <div className="promotions-review w-full overflow-hidden">
      <Accordion size="large" presentation="box-shadow" className="font-body w-full">
        <div className="flex w-full flex-col gap-4">
          <ComboReviewSetup />
          <ComboReviewDisplay />
          <ComboReviewProducts />
        </div>
      </Accordion>
    </div>
  )
}
